import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloat from '@/components/WhatsAppFloat';
import { CheckCircle, Award, Users } from 'lucide-react';

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Hakkımızda | Aden İklimlendirme İzmir Teknik Servis</title>
        <meta
          name="description"
          content="Aden İklimlendirme, İzmir genelinde 15 yıllık tecrübesiyle klima, kombi ve beyaz eşya teknik servis hizmeti sunar. 7/24 destek, uzman ekip ve garantili onarım."
        />
      </Helmet>

      <Navbar />

      <section className="py-20 md:py-32" data-testid="about-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-navy mb-6">
                İzmir'in Güvenilir Teknik Servisi
              </h1>
              <p className="text-lg text-slate-700 leading-relaxed text-justify mb-6">
                Aden İklimlendirme olarak, 15 yılı aşkın saha tecrübemizle İzmir genelinde klima, kombi ve beyaz eşya teknik servis hizmetleri sunuyoruz.
                Arıza tespiti, bakım ve onarım süreçlerinde kalıcı çözüm üretmeyi temel prensibimiz olarak benimsiyoruz.
              </p>

              <p className="text-lg text-slate-700 leading-relaxed text-justify mb-6">
                Alanında deneyimli ve sertifikalı teknik ekibimizle 7/24 servis desteği sağlıyor, aynı gün müdahale ile müşterilerimizin konforunu kesintiye uğratmadan çözümler sunuyoruz.
                Şeffaf fiyat politikası, garantili işçilik ve müşteri memnuniyeti odaklı hizmet anlayışımızla güvenilir bir servis markası haline geldik.
              </p>
            </div>
            <div>
              <img
                src="https://images.pexels.com/photos/32497161/pexels-photo-32497161.jpeg"
                alt="Aden İklimlendirme teknik servis ekibi İzmir"
                className="rounded-lg shadow-lg"
              />
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-20">
            <div className="bg-light p-8 rounded-lg text-center" data-testid="stat-experience">
              <Award size={48} className="mx-auto mb-4 text-orange" />
              <h3 className="text-4xl font-bold text-navy mb-2">15+</h3>
              <p className="text-slate-600">Yıllık Tecrübe</p>
            </div>
            <div className="bg-light p-8 rounded-lg text-center" data-testid="stat-customers">
              <Users size={48} className="mx-auto mb-4 text-orange" />
              <h3 className="text-4xl font-bold text-navy mb-2">1000+</h3>
              <p className="text-slate-600">Mutlu Müşteri</p>
            </div>
            <div className="bg-light p-8 rounded-lg text-center" data-testid="stat-certified">
              <CheckCircle size={48} className="mx-auto mb-4 text-orange" />
              <h3 className="text-4xl font-bold text-navy mb-2">%100</h3>
              <p className="text-slate-600">Sertifikalı Teknik Ekip</p>
            </div>
          </div>

          <div className="flex flex-col bg-white p-12 rounded-lg shadow-sm">
            <h2 className="text-3xl font-bold text-navy mb-8 text-center">
              Misyon & Vizyon
            </h2>
            <div className="grid md:grid-cols-2 gap-12">
              <div>
                <h3 className="text-2xl font-bold text-orange mb-4 text-center">Misyonumuz</h3>
                <p className="text-slate-700 text-justify">
                  Müşterilerimize hızlı, güvenilir ve kalıcı teknik servis çözümleri sunmak; arıza tespitinden onarım sürecine kadar her aşamada şeffaf ve garantili hizmet vermek temel misyonumuzdur.
                </p>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-orange mb-4 text-center">Vizyonumuz</h3>
                <p className="text-slate-700 text-justify">
                  İzmir genelinde teknik servis alanında güvenilirliği ve hizmet kalitesiyle öne çıkan, müşteri memnuniyetinde sürdürülebilir başarı sağlayan öncü bir marka olmaktır.
                </p>
              </div>
            </div>
            <div className="mt-12 text-center max-w-3xl mx-auto">
              <p className="text-lg text-slate-700 leading-relaxed text-justify">
                Aden İklimlendirme olarak her arızaya sadece onarım değil, kalıcı çözüm yaklaşımıyla bakıyoruz.
                Ev, iş yeri ve ofislerde yaşam konforunu aksatan teknik sorunlara hızlı müdahale ederek güvenilir servis deneyimi sunuyoruz.
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default AboutPage;
